import cx from "ui/cx";
import styles from "./SubmenuInnerButton.module.scss";

export default function SubmenuInnerButton({ children, className, ...props }: React.HTMLAttributes<HTMLElement>) {
  return (
    <div className={cx(styles.wrapper, className)} {...props}>
      {children}
    </div>
  );
}
